import React from "react";
import { Outlet } from "react-router-dom";
import TopNavbar from "../../components/topNavbar";
import Footer from "../../components/footer";

const Layout = (props: any) => {
  return (
    <div className="text-body-text h-full flex flex-col">
      <header>
        {/* Skip to content link for keyboard navigation */}
        <a
          href="#main"
          style={{
            position: "absolute",
            borderRadius: "20px",
            left: 0,
            top: 0,
            transform: "translateY(-100%)",
            backgroundColor: "#d90d1c",
            color: "white",
            padding: "0.75rem 1.5rem",
            zIndex: 9999,
            fontWeight: 500,
            fontSize: "0.875rem",
            textDecoration: "none",
            transition: "transform 0.2s ease-in-out",
          }}
          onFocus={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.outline = "2px solid #d90d1c";
            e.currentTarget.style.outlineOffset = "2px";
          }}
          onBlur={(e) => {
            e.currentTarget.style.transform = "translateY(-100%)";
            e.currentTarget.style.outline = "none";
          }}
        >
          Skip To Main Content
        </a>
        <TopNavbar />
      </header>

      <div className="grow overflow-auto" id="outlet">
        <main id="main">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
